import React from 'react'
import { Link } from 'react-router-dom'
import {
  SophiePhoto,
  JaneLittlePhoto,
  PayalPhoto,
  DeepaPhoto,
  JuliePhoto
} from '../../assets'

export const GRNDaDExecutiveCommittee: React.FC = () => {
  const committeeMembers = [
    {
      name: 'Dr. Sophie Lanzkron',
      title: 'M.D., M.H.S. Professor of Medicine',
      position:
        'Director, Sickle Cell Center for Adults, The Johns Hopkins Hospital',
      image: SophiePhoto
    },
    {
      name: 'Jane Little',
      title: 'M.D., Professor of Medicine, Division of Hematology and Oncology',
      position: 'Director, UNC Comprehensive Sickle Cell Disease program',
      image: JaneLittlePhoto
    },
    {
      name: 'Payal C Desai',
      title:
        'M.D., Associate Professor of Internal Medicine, Division of Hematology',
      position:
        'Director of sickle cell research for The Ohio State University and co-director of the Sickle Cell Program',
      image: PayalPhoto
    },
    {
      name: 'Deepa G. Manwani',
      title: 'M.D., Pediatric Hematology-Oncology',
      position:
        "Director, Pediatric Hematology at Children's Hospital at Montefiore, as well as a Professor in the Department of Pediatrics at Albert Einstein College of Medicine",
      image: DeepaPhoto
    },
    {
      name: 'Julie Kanter',
      title: 'M.D., Associate Professor of Medicine',
      position: 'Co-Director of the Comprehensive Sickle Cell Center at UAB',
      image: JuliePhoto
    }
  ]

  return (
    <main
      className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16"
      data-testid="grndad-executive-committee-container"
    >
      <div className="max-w-7xl mx-auto">
        {/* Sub-navigation */}
        <nav className="mb-8 border-b border-[#3C2416]/20 pb-4">
          <div className="flex flex-wrap gap-6">
            <Link
              to="/grndad/about"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              About
            </Link>
            <Link
              to="/grndad/locations"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Locations
            </Link>
            <Link
              to="/grndad/executive-committee"
              className="text-[#A6410A] font-medium border-b-2 border-[#A6410A] pb-1"
            >
              Executive Committee
            </Link>
            <Link
              to="/grndad/benefits-of-joining"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Benefits of Joining
            </Link>
            <Link
              to="/grndad/speaker-series"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Speaker Series
            </Link>
          </div>
        </nav>

        <h1 className="text-4xl md:text-5xl font-serif text-[#3C2416] mb-8">
          Executive Committee
        </h1>

        <div className="space-y-8">
          {committeeMembers.map((member, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md p-8"
              data-testid={`member-card-${index}`}
            >
              <div className="flex flex-col md:flex-row gap-6">
                <div className="flex-shrink-0">
                  <div className="w-32 h-32 rounded-full overflow-hidden bg-[#A6410A]/10">
                    <img
                      src={member.image}
                      alt={member.name}
                      className={`w-full h-full object-cover ${
                        member.name === 'Julie Kanter'
                          ? 'object-[center_10%]'
                          : 'object-[center_20%]'
                      }`}
                    />
                  </div>
                </div>
                <div className="flex-1">
                  <h3
                    className="text-2xl font-semibold text-[#A6410A] mb-2"
                    data-testid={`member-name-${index}`}
                  >
                    {member.name}
                  </h3>
                  <p
                    className="text-lg text-[#3C2416] font-medium mb-3"
                    data-testid={`member-title-${index}`}
                  >
                    {member.title}
                  </p>
                  <p className="text-[#3C2416] leading-relaxed">
                    {member.position}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold text-[#A6410A] mb-4">
            About the Executive Committee
          </h2>
          <p className="text-[#3C2416] leading-relaxed mb-6">
            The GRNDaD Executive Committee consists of internationally
            recognized physicians who specialize in the care of both children
            and adults with sickle cell disease. These leaders bring decades of
            experience in clinical care, research, and quality improvement
            initiatives to guide the registry&apos;s mission and objectives.
          </p>
          <p className="text-[#3C2416] leading-relaxed">
            The committee oversees the strategic direction of GRNDaD, ensures
            data quality and integrity, and facilitates collaborative research
            opportunities across participating sites.
          </p>
        </div>

        {/* Contact Information Section */}
        <div className="mt-12 bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold text-[#A6410A] mb-4">
            Contact Information
          </h2>
          <p className="text-[#3C2416] mb-4">
            For questions about the GRNDaD Executive Committee or to get in
            touch with our leadership team:
          </p>
          <a
            href="mailto:GRNDaDSCD@gmail.com"
            className="text-[#A6410A] font-medium hover:underline text-lg"
          >
            GRNDaDSCD@gmail.com
          </a>
        </div>
      </div>
    </main>
  )
}
